const HiddenCanvas = ({ id, height, width }) => (
  <canvas className="hidden" id={id} height={height} width={width}></canvas>
);

export default HiddenCanvas;
